import isEmail from 'validator/lib/isEmail';
import UTILS from './utils';

const emailsValidator = {
  getMessage(field, params, data) {
    return (data && data.message) || $T('validation.force_error');
  },
  validate(value, args) {
    return new Promise(resolve => {
      var max = Number(args[0]);
      var values = value.trim().split(/\n/);
      var count = 0;
      var err = null;
      var dup = null;
      var entried = {};
      for (var i = 0; i < values.length; i++) {
        var v = values[i].trim().toLowerCase();
        if (v == '') continue;
        if (!isEmail(v)) {
          err = v;
          break;
        } else if (entried[v]) {
          dup = v;
          break;
        } else {
          entried[v] = true;
          count++;
        }
      }
      if (count > max) {
        resolve({
          valid: false,
          data: { message: $T('validation.input_count', { max: max }) },
        });
      } else if (err != null) {
        resolve({
          valid: false,
          data: { message: $T('validation.email_specified', { value: err }) },
        });
      } else if (dup != null) {
        resolve({
          valid: false,
          data: { message: $T('validation.duplicated', { value: dup }) },
        });
      } else {
        resolve({
          valid: true,
          data: { message: null },
        });
      }
    });
  },
};

const lenMaxValidator = {
  getMessage(field, params, data) {
    return (data && data.message) || $T('validation.force_error');
  },
  validate(values, args) {
    return new Promise(resolve => {
      var max = Number(args[0]);
      if (values == null || !Array.isArray(values) || values.length <= max) {
        resolve({
          valid: true,
          data: { message: null },
        });
        return;
      }
      resolve({
        valid: false,
        data: { message: $T('validation.len_max', { max: max }) },
      });
    });
  },
};

const invitePrefixRegex = UTILS.getHost().replace('.', '\\.') + '/invite/';
const inviteParamRegex = '((o/[1-9][0-9]*)|([a-f0-9]+))';
const invitePathRegex = invitePrefixRegex + inviteParamRegex;

const inviteCodeValidator = {
  getMessage(field, params, data) {
    return (data && data.message) || $T('validation.force_error');
  },
  validate(value, args) {
    return new Promise(resolve => {
      value = value.trim().toLowerCase();
      var host = UTILS.getHost();
      if (value.startsWith('http')) {
        if (!new RegExp('^' + invitePathRegex + '$').test(value)) {
          resolve({
            valid: false,
            data: { message: $T('validation.invalid_invite_url') },
          });
          return;
        }
      } else {
        if (!new RegExp('^' + inviteParamRegex + '$').test(value)) {
          resolve({
            valid: false,
            data: { message: $T('validation.invalid_invite_code') },
          });
          return;
        }
      }
      resolve({
        valid: true,
        data: { message: null },
      });
    });
  },
};
export { emailsValidator, lenMaxValidator, inviteCodeValidator, invitePrefixRegex, inviteParamRegex, invitePathRegex };
